import { Button } from "@accurx/design";
import styled from "styled-components";

export const DropdownButton = styled(Button)`
    white-space: nowrap;
    width: 100%;
`;
